import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import styles from './styles';
import './knowledgebase.scss';
import { useParams, useLocation, Link } from 'react-router-dom';
import KnowledgebaseItem from './KnowledgebaseItem';
import CreateFeedItem from '../Feed/CreateFeedItem/CreateFeedItem';
import { updateTaskRequest } from '../../actionCreators/employeeOnboarding';
import { logFirebaseEvent } from '../../firebase/analytics';
import GridContainer from '../global/GridContainer/GridContainer';
import { updateKnowledgebaseViewsRequest } from '../../actionCreators/knowledgebase';
import knowledgebaseApi from '../../api/knowledgebase';

const KnowledgebaseDetailsComponent = props => {
  const { id } = useParams();
  const data = useLocation();

  let item = null;
  let taskId = null;
  let firstTimeLogin = '';
  if (data && data.state) {
    item = data.state.item;
    taskId = data.state.taskId;
    firstTimeLogin = data.state.firstTimeLogin;
  }

  const [showShareModal, togglShowShareModal] = useState(false);
  const [knowledgebaseItem, setKnowledgebaseItem] = useState(item);

  const onToggleCreateFeed = isActive => {
    togglShowShareModal(isActive);
  };

  const fetchKnowledgeBaseItemDetails = async () => {
    try {
      const response = await knowledgebaseApi.getknowledgebaseItem(id);
  
      if (response?.success) {
        setKnowledgebaseItem(response.item);
      }
    } catch (error) {
      console.error('Failed to fetch knowledgebase item:', error);
    }
  };

  useEffect(() => {
    props.updateKnowledgebaseViews(id);
    if (!knowledgebaseItem) { 
      fetchKnowledgeBaseItemDetails();
    }
  }, []);

  return (
    <div className='knowledgebase'>
      <GridContainer>
        <div className='knowledgebase-header'>
          <p className='knowledgebase-header-text page-title'>Knowledgebase</p>
        </div>
        <div className='knowledgebase-content'>
          <div style={styles.knowledgebaseItemSubheader}>
            <Link
              to={
                !taskId ? '/knowledgebase' : `/employee_onboarding?firstTimeLogin=${firstTimeLogin}`
              }
              className='single-challenge__back-text'
            >
              &#x276E; {taskId ? 'Back to Onboarding' : 'Back to Knowledgebase'}
            </Link>
            {knowledgebaseItem && !taskId && (
              <div
                style={styles.knowledgebaseShareButton}
                onClick={() => togglShowShareModal(true)}
              >
                Share
              </div>
            )}
          </div>
          {showShareModal ? (
            <CreateFeedItem
              onToggleActive={onToggleCreateFeed}
              action={'share'}
              title={'Share knowledgebase'}
              isFocused={true}
              shouldShowAttachedMedia={false}
              knowledgebaseItem={knowledgebaseItem}
            />
          ) : null}
          {knowledgebaseItem && (
            <div style={styles.postListContainer}>
              <KnowledgebaseItem
                viewOnly
                item={knowledgebaseItem}
                updateTask={props.updateOnboardingTask}
                updateKnowledgebaseViews={props.updateKnowledgebaseViews}
                taskId={taskId}
              />
            </div>
          )}
        </div>
      </GridContainer>
    </div>
  );
};

const KnowledgebaseDetails = (props) => {
  const dispatch = useDispatch();

  const actions = {
    updateOnboardingTask: taskId =>
      dispatch(
        updateTaskRequest({ taskId }),
        logFirebaseEvent({
          event: 'employee_onboarding',
          action: 'task_completed',
        }),
      ),
    updateKnowledgebaseViews: itemId => dispatch(updateKnowledgebaseViewsRequest(itemId)),
  };

  return <KnowledgebaseDetailsComponent {...props} {...actions} />;
};

export default KnowledgebaseDetails;